import React from "react"
import { IClientDocument, EScheduleListType } from "../../../models"
import ScheduleList from "../../../components/schedule/schedule_list/ScheduleList"

interface IProps {
    readonly?: boolean
    client: IClientDocument
}

const ClientDetailsSchedule: React.SFC<IProps> = (props: IProps) => {
    return (
        <ScheduleList
            readonly={props.readonly}
            type={EScheduleListType.ClientSchedule}
            client={props.client}
        />
    )
}

export default ClientDetailsSchedule